export default __webpack_public_path__ + "static/trainingHero-faf9497e29e8e6daf32d8adafbcf13bc.png";